<loading-spinner></loading-spinner>
<router-outlet></router-outlet>
<app-modal></app-modal>



// WEBPACK FOOTER //
// ./src/app/app.component.html